var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "deposit-form" }, [
    _c("div", { staticClass: "region-tabs" }, [
      _c(
        "button",
        {
          staticClass: "tab-btn",
          class: { active: _vm.activeTab === "tw" },
          attrs: { "data-tab": "tw" },
          on: {
            click: function ($event) {
              _vm.activeTab = "tw"
            },
          },
        },
        [_vm._v("\n\t\t\t台灣\n\t\t")]
      ),
      _c(
        "button",
        {
          staticClass: "tab-btn",
          class: { active: _vm.activeTab === "hk" },
          attrs: { "data-tab": "hk" },
          on: {
            click: function ($event) {
              _vm.activeTab = "hk"
            },
          },
        },
        [_vm._v("\n\t\t\t香港\n\t\t")]
      ),
    ]),
    _c("div", { staticClass: "form-group" }, [
      _c("label", [_vm._v("選擇儲值金額：")]),
      _vm.gameCode == "cztxtw"
        ? _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.model.productId,
                  expression: "model.productId",
                },
              ],
              staticClass: "form-control",
              on: {
                change: function ($event) {
                  var $$selectedVal = Array.prototype.filter
                    .call($event.target.options, function (o) {
                      return o.selected
                    })
                    .map(function (o) {
                      var val = "_value" in o ? o._value : o.value
                      return val
                    })
                  _vm.$set(
                    _vm.model,
                    "productId",
                    $event.target.multiple ? $$selectedVal : $$selectedVal[0]
                  )
                },
              },
            },
            [
              _c("option", { attrs: { value: "" } }, [_vm._v("選擇金額：")]),
              _c("option", { attrs: { value: "com.cztxtw.huikuan320" } }, [
                _vm._v("TWD10000/HKD2778 (USD 320)"),
              ]),
              _c("option", { attrs: { value: "com.cztxtw.huikuan640" } }, [
                _vm._v("TWD20000/HKD5556 (USD 640)"),
              ]),
              _c("option", { attrs: { value: "com.cztxtw.huikuan1600" } }, [
                _vm._v("TWD50000/HKD13889 (USD 1600)"),
              ]),
              _c("option", { attrs: { value: "com.cztxtw.huikuan2560" } }, [
                _vm._v("TWD80000/HKD22222 (USD 2560)"),
              ]),
              _c("option", { attrs: { value: "com.cztxtw.huikuan3200" } }, [
                _vm._v("TWD100000/HKD27778 (USD 3200)"),
              ]),
            ]
          )
        : _vm._e(),
      _vm.gameCode == "sgyjltw"
        ? _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.model.productId,
                  expression: "model.productId",
                },
              ],
              staticClass: "form-control",
              on: {
                change: function ($event) {
                  var $$selectedVal = Array.prototype.filter
                    .call($event.target.options, function (o) {
                      return o.selected
                    })
                    .map(function (o) {
                      var val = "_value" in o ? o._value : o.value
                      return val
                    })
                  _vm.$set(
                    _vm.model,
                    "productId",
                    $event.target.multiple ? $$selectedVal : $$selectedVal[0]
                  )
                },
              },
            },
            [
              _c("option", { attrs: { value: "" } }, [_vm._v("選擇金額：")]),
              _c(
                "option",
                { attrs: { value: "com.sgyjltw.web32000_2_30027" } },
                [_vm._v("TWD10000/HKD2778 (USD 320)")]
              ),
              _c(
                "option",
                { attrs: { value: "com.sgyjltw.web64000_2_30028" } },
                [_vm._v("TWD20000/HKD5556 (USD 640)")]
              ),
              _c(
                "option",
                { attrs: { value: "com.sgyjltw.webhk1000_2_30029" } },
                [_vm._v("TWD31250/HKD8680 (USD 1000)")]
              ),
              _c(
                "option",
                { attrs: { value: "com.sgyjltw.webhk1600_2_30030" } },
                [_vm._v("TWD50000/HKD13889 (USD 1600)")]
              ),
              _c(
                "option",
                { attrs: { value: "com.sgyjltw.webhk2560_2_30031" } },
                [_vm._v("TWD80000/HKD22222 (USD 2560)")]
              ),
              _c(
                "option",
                { attrs: { value: "com.sgyjltw.webhk3200_2_30032" } },
                [_vm._v("TWD100000/HKD27778 (USD 3200)")]
              ),
            ]
          )
        : _vm._e(),
    ]),
    _c("div", { staticClass: "form-group" }, [
      _c("label", [_vm._v("銀行卡后五位：")]),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.model.bankNo,
            expression: "model.bankNo",
          },
        ],
        staticClass: "form-control",
        attrs: { placeholder: "請輸入銀行卡后五位" },
        domProps: { value: _vm.model.bankNo },
        on: {
          input: function ($event) {
            if ($event.target.composing) return
            _vm.$set(_vm.model, "bankNo", $event.target.value)
          },
        },
      }),
    ]),
    _c(
      "div",
      { staticClass: "form-group" },
      [
        _c("label", [_vm._v("上傳憑證")]),
        _c("ImageUploader", {
          ref: "imageUploader",
          on: { uploaded: _vm.handleUploadSuccess },
        }),
      ],
      1
    ),
    _c("div", { staticClass: "form-group" }, [
      _c("label", [_vm._v("備註：")]),
      _c("textarea", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.model.remark,
            expression: "model.remark",
          },
        ],
        staticClass: "form-control",
        attrs: {
          rows: "3",
          maxlength: "100",
          placeholder: "請輸入備註信息（選填）",
        },
        domProps: { value: _vm.model.remark },
        on: {
          input: function ($event) {
            if ($event.target.composing) return
            _vm.$set(_vm.model, "remark", $event.target.value)
          },
        },
      }),
    ]),
    _c(
      "button",
      {
        staticClass: "submit-btn",
        attrs: { id: "submit_btn" },
        on: { click: _vm.submitBankRemit },
      },
      [_vm._v("提交申請")]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }